module.exports = __webpack_public_path__ + "img/hiw-image.dbf045ab.png";